import i18n from 'services/base/i18n';

export default {
  // Text describing the title of the page
  title: () => i18n.pgettext('Pages|Email Verification', 'Email Verification'),

  // An email placeholder that should not be shown to the user unless they do hacker-like things
  // This is purely for display, so security is no issue
  emailPlaceholder: () => i18n.pgettext('Pages|Email Verification', 'your email address'),

  requestedFor: (email: string) => i18n.sprintf(
    // Text for the confirmation message. Put a %s where the email should be inserted.
    i18n.pgettext('Pages|Email Verification', 'We have sent an email to %s. Please click the link in the email then press "Continue" when you are done.',),
    email,
  ),

  // An error to show users if their email address is still not verified
  emailNotVerifiedError: () => i18n.pgettext('Pages|Email Verification', 'Your email address is still not verified'),

  // Text for continue button
  proceed: () => i18n.pgettext('Pages|Email Verification', 'CONTINUE'),

  // Text for continue button
  resend: () => i18n.pgettext('Pages|Email Verification', 'RESEND CODE'),

  // Text to go to the edit settings page
  editSettings: () => i18n.pgettext('Pages|Email Verification', 'EDIT SETTINGS'),

  // Text for log out button
  logout: () => i18n.pgettext('Pages|Email Verification', 'LOG OUT'),
};
